import React, { useState } from "react";
import { Button, CloseButton, Modal } from "react-bootstrap";


const MessageBox=({onMessageBoxClose,title,message,variant})=> {
  const [modalShow, setModalShow] = useState(true);

  const closeHandler=()=>{
    setModalShow(false);
    onMessageBoxClose();
  }
  return (
    <>
     
     
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={closeHandler}
          />
        </Modal.Header>
        <Modal.Body>
          <p>
           {message}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant={variant} onClick={closeHandler}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MessageBox;